
namespace RioERP.Products {
    export class PacksColumns {
        static columnsKey = 'Products.Packs';
    }
}